import React from 'react'
import { connect } from 'react-redux';

import RepaymentYear from '../../../../../../components/RepaymentYear'
import RepaymentFrequency from './RepaymentFrequency'
import YesOrNoForm from '../../../commons/YesOrNoForm'

import {
  getLoanDetailSettings
} from 'containers/LoanApplication/reducers';

class Settings extends React.Component {
  render() {
    const {
      settings: {
        repaymentYear,
        repaymentFrequency,
        offsetAccount,
      },
      showOffsetAccount,
    } = this.props

    return(
      <div className='card card-single'>
        <div className='card-header'>
          Loan settings
        </div>

        <div className='card-body'>
          <RepaymentYear
            label='How many years do you want your loan for?'
            defaultValue={ repaymentYear }
            onChange={ (value) => this.props.onChange({ repaymentYear: value }) }
          />
          <RepaymentFrequency
            checked={ repaymentFrequency }
            onChange={ (value) => this.props.onChange({ repaymentFrequency: value }) }
          />
          {
            showOffsetAccount && (
              <YesOrNoForm
                label='Would you like an offset account?'
                checked={ offsetAccount }
                onChange={ (value) => this.props.onChange({ offsetAccount: value }) }
              />
            )
          }
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => ({
  settings: getLoanDetailSettings(state),
})

export default connect(mapStateToProps)(Settings);
